import { combineReducers } from 'redux';
import { ActionType } from 'typesafe-actions';

import { sportsActions } from './actions';
import {
  SPORTS_FAILURE,
  SPORTS_REQUEST,
  SPORTS_SUCCESS,
} from '../../constants/sports';

export type Sport = {
  id: string;
  code: string;
  name: string;
  active: boolean;
};
export type SportsState = {
  requested: boolean;
  data: { sports: Sport[] };
  isLoading: boolean;
  error: string | null;
};
export type SportsActions = ActionType<typeof sportsActions>;

export const sportsReducer = combineReducers<SportsState, SportsActions>({
  requested: (state = false, action) => {
    switch (action.type) {
      case SPORTS_REQUEST:
        return true;
      default:
        return state;
    }
  },
  data: (state = { sports: [] }, action) => {
    switch (action.type) {
      case SPORTS_SUCCESS:
        return action.payload;
      default:
        return state;
    }
  },
  isLoading: (state = false, action) => {
    switch (action.type) {
      case SPORTS_REQUEST:
        return true;
      default:
        return false;
    }
  },
  error: (state = null, action) => {
    switch (action.type) {
      case SPORTS_FAILURE:
        return action.payload.message || action.payload.detail;
      default:
        return null;
    }
  },
});
